import React from "react";
import { Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { images } from "../mock";

export default function Welcome() {
  const { t } = useLanguage();
  const { ref, visible } = useReveal();

  return (
    <section className="hsc-net-bg py-20 lg:py-24">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center hsc-reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        <div className="relative order-2 lg:order-1">
          <div className="grid grid-cols-2 gap-4">
            <img
              src={images.laptopOutdoor}
              alt="Turista connesso con laptop"
              className="rounded-2xl h-64 w-full object-cover hsc-card-shadow mt-8"
            />
            <img
              src={images.touristLuggage}
              alt="Viaggiatore che usa lo smartphone"
              className="rounded-2xl h-64 w-full object-cover hsc-card-shadow"
            />
          </div>
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 hsc-glass rounded-full px-5 py-2.5 border border-white/70 shadow-lg text-sm font-semibold text-primary">
            {t.welcome.tagline}
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-primary font-semibold text-sm tracking-[0.18em] uppercase">
            {t.welcome.eyebrow}
          </span>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[30px] sm:text-[38px] leading-tight tracking-[-0.02em]">
            {t.welcome.title}
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-slate-700">{t.welcome.body1}</p>
          <p className="mt-4 text-[16px] leading-relaxed text-slate-700">{t.welcome.body2}</p>

          <ul className="mt-7 space-y-3">
            {t.welcome.highlights.map((h, i) => (
              <li key={i} className="flex items-center gap-3">
                <span className="grid place-items-center w-7 h-7 rounded-full bg-primary/10 text-primary shrink-0">
                  <Check className="w-4 h-4" strokeWidth={3} />
                </span>
                <span className="text-[15px] font-medium text-slate-700">{h}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
